type AdminErrorStateProps = {
  message: string;
};

/** 中央配置のエラーメッセージ */
export default function AdminErrorState({ message }: AdminErrorStateProps) {
  return (
    <div className="flex min-h-[360px] items-center justify-center">
      <div className="text-center">
        <p className="text-lg font-bold text-main">エラーが発生しました</p>
        <p className="mt-2 text-sm text-sub">{message}</p>
      </div>
    </div>
  );
}
